import { cn } from '../utils/cn';

export const MarginIcon = (props: React.ComponentProps<'svg'>) => {
  const { className, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('size-4', className)}
      {...rest}
    >
      <path d="M3 7H17C18.1046 7 19 7.59695 19 8.33333V17.6667C19 18.403 18.1046 19 17 19H3C1.89543 19 1 18.403 1 17.6667V8.33333C1 7.59695 1.89543 7 3 7Z" />
      <path d="M1 1H19" />
    </svg>
  );
};
